import React from 'react';
import { UtilityBanner } from '@grubhubprod/gh-cookbook-react';
import { ReportingRequirementControl } from 'src/components/enterprise/features/Corporate/components/Form/ReportingRequirementWrapper/ReportingRequirementControl/ReportingRequirementControl';
import { useReportingRequirementWrapper } from 'src/components/enterprise/features/Corporate/components/Form/ReportingRequirementWrapper/hooks/useReportingRequirementWrapper';

export function ReportingRequirementWrapper(): JSX.Element {
  const { showEmployeeWarning } = useReportingRequirementWrapper();

  return (
    <>
      <ReportingRequirementControl name="reporting" id="reporting" />
      {showEmployeeWarning && (
        <UtilityBanner
          flavor="error"
          prominence="quiet"
          message="Remember to assign all employees a department"
        />
      )}
    </>
  );
}
